import { resolveComponent as _resolveComponent, createVNode as _createVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createBlock as _createBlock, toDisplayString as _toDisplayString, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, withCtx as _withCtx, createSlots as _createSlots, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-3e26098c")

_pushScopeId("data-v-3e26098c")
const _hoisted_1 = { class: "overflow-hidden" }
const _hoisted_2 = { class: "flex" }
const _hoisted_3 = /*#__PURE__*/_createTextVNode("合成")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("保存")
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_el_page_header = _resolveComponent("el-page-header")
  const _component_el_divider = _resolveComponent("el-divider")
  const _component_slot_form = _resolveComponent("slot-form")
  const _component_el_button = _resolveComponent("el-button")
  const _component_el_card = _resolveComponent("el-card")
  const _component_el_step = _resolveComponent("el-step")
  const _component_el_steps = _resolveComponent("el-steps")
  const _component_demo_form = _resolveComponent("demo-form")
  const _component_el_dialog = _resolveComponent("el-dialog")

  return (_openBlock(), _createBlock(_Fragment, null, [
    _createVNode("div", _hoisted_1, [
      _createVNode(_component_el_page_header, {
        onBack: _ctx.goBack,
        content: "制作音频"
      }, null, 8, ["onBack"]),
      _createVNode(_component_el_divider),
      _createVNode(_component_el_steps, {
        class: "slots",
        direction: "vertical",
        active: -1,
        "align-center": ""
      }, {
        default: _withId(() => [
          (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.slots, (slot) => {
            return (_openBlock(), _createBlock(_component_el_step, {
              key: slot.id,
              title: _ctx.getTitle(slot)
            }, _createSlots({
              description: _withId(() => [
                (slot.id !== -1)
                  ? (_openBlock(), _createBlock(_component_slot_form, {
                      key: 0,
                      slotSliceMap: _ctx.slotSliceMap,
                      "onUpdate:slotSliceMap": _cache[1] || (_cache[1] = ($event: any) => (_ctx.slotSliceMap = $event)),
                      editable: false,
                      templateId: _ctx.templateId,
                      slotData: slot
                    }, null, 8, ["slotSliceMap", "templateId", "slotData"]))
                  : (_openBlock(), _createBlock(_component_el_card, { key: 1 }, {
                      default: _withId(() => [
                        _createVNode("div", _hoisted_2, [
                          _createVNode(_component_el_button, {
                            disabled: !_ctx.allFinished,
                            class: "font-20",
                            type: "success",
                            onClick: _ctx.mergeDemo
                          }, {
                            default: _withId(() => [
                              _hoisted_3
                            ]),
                            _: 1
                          }, 8, ["disabled", "onClick"]),
                          (_ctx.demoUrl)
                            ? (_openBlock(), _createBlock("audio", {
                                key: 0,
                                class: "margin-left-10",
                                src: _ctx.demoUrl,
                                controls: ""
                              }, null, 8, ["src"]))
                            : _createCommentVNode("", true),
                          (_ctx.demoUrl)
                            ? (_openBlock(), _createBlock(_component_el_button, {
                                key: 1,
                                class: "margin-left-10 font-20",
                                type: "primary",
                                onClick: _ctx.save
                              }, {
                                default: _withId(() => [
                                  _hoisted_4
                                ]),
                                _: 1
                              }, 8, ["onClick"]))
                            : _createCommentVNode("", true)
                        ])
                      ]),
                      _: 1
                    }))
              ]),
              _: 2
            }, [
              (slot.id !== -1)
                ? {
                    name: "icon",
                    fn: _withId(() => [
                      _createVNode("strong", null, _toDisplayString(_ctx.slots.indexOf(slot) + 1), 1)
                    ])
                  }
                : undefined
            ]), 1032, ["title"]))
          }), 128))
        ]),
        _: 1
      })
    ]),
    _createVNode(_component_el_dialog, {
      title: "保存成品",
      modelValue: _ctx.demoDialogVisible,
      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => (_ctx.demoDialogVisible = $event)),
      width: "40%"
    }, {
      default: _withId(() => [
        _createVNode(_component_demo_form, {
          demo: _ctx.demo,
          onCancel: _cache[2] || (_cache[2] = ($event: any) => (_ctx.demoDialogVisible = false)),
          onSuccess: _ctx.demoUpdated
        }, null, 8, ["demo", "onSuccess"])
      ]),
      _: 1
    }, 8, ["modelValue"])
  ], 64))
})